import React from "react";
import svg97 from '../../../assets/svg/svg97.svg'

function OurImpact() {
  return (
    <div className="bg-[linear-gradient(135deg,#000_0%,#231F20_100%)] h-auto lg:py-[5rem] py-3 lg:px-[5.69rem] px-3 flex lg:flex-row flex-col justify-between items-center">
      <div className="flex flex-col">
        <div className="text-[3rem] font-[500] leading-[3.375rem] text-[#fff]">
          Our Impact
        </div>
        <div className="mt-[1.5rem] text-[#D1D5DB] font-[400] leading-[1.625rem] lg:max-w-[33.9775rem] w-full">
          Ndovu Pay supports organizations across Kenya and beyond in managing
          millions of shillings in transactions every month. From petty cash to
          payrolls, we're helping businesses streamline financial management and
          build lasting credibility.
        </div>

        <div className="flex mt-[1.5rem] lg:flex-row flex-col gap-y-[1.125rem] justify-between">
          <div className="flex gap-[1.12rem]">
            <div className="border-[2px] text-ndovuRed h-auto"></div>
            <div className="flex flex-col gap-[.25rem]">
              <span className="text-[#DB2A12] text-[1.875rem] font-[600] leading-[2.25rem]">
                5,000+
              </span>
              <span className="text-[#9CA3AF] text-[.875rem] font-[400] leading-[1.5rem]">
                Active Businesses
              </span>
            </div>
          </div>

          <div className="flex gap-[1.12rem]">
            <div className="border-[2px] text-ndovuRed h-auto"></div>
            <div className="flex flex-col gap-[.25rem]">
              <span className="text-[#DB2A12] text-[1.875rem] font-[600] leading-[2.25rem]">
                10M+OurImpact
              </span>
              <span className="text-[#9CA3AF] text-[.875rem] font-[400] leading-[1.5rem]">
                TransactionBusinessess Processed
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="p-[2.0625rem] lg:w-[34.5rem] w-full lg:h-[34.5rem] h-auto">
        <img src={svg97} alt="svg97"/>
      </div>
    </div>
  );
}

export default OurImpact;
